function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.513 12.38c-2.117 0-3.835-1.729-3.835-3.862 0-2.135 1.718-3.863 3.835-3.863s3.835 1.729 3.835 3.863c0 2.132-1.718 3.862-3.835 3.862m0-12.38C6.825 0 3.025 3.827 3.025 8.549c0 4.46 3.844 10.213 6.411 13.014.959 1.045 2.076 2.454 2.076 2.454s1.2-1.417 2.229-2.493C16.306 18.84 20 13.451 20 8.549 20 3.827 16.2 0 11.513 0"
});

function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgPin;